module.exports = __webpack_public_path__ + "static/ab1-f8768843cb98a3feddc9a35f2917134e.png";